<template>
	<div v-show="visible" class="tips-mask-t" @click.self="onCancel">
		<div class="tips-wrapper" :class="{'tips-start':actionShow,'tips-end':!actionShow}">
			<div class="tips-font"><p>{{message}}</p></div>
			<div class="tips-btns">
				<a class="tips-two-btn tips-marbot red-font" @click="onConfrim">{{btns[0]}}</a>
				<a v-show="type !== 'alert'" class="tips-two-btn" @click="onCancel">{{btns[1]}}</a>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		value: Boolean,
		message: String,
		btns: {
			type: Array,
			default: () => {
				return ['确定', '取消']
			}
		},
		type: String
	},
	data () {
		return {
			visible: false,
			actionShow: false,
			confirmHandler: null,
			cancelHandler: null
		}
	},
	watch: {
		value (val) {
			if (val) {
				this.visible = true
				this.actionShow = true
				this.$emit('on-show')
			} else {
				this.hide()
			}
		}
	},
	methods: {
		onConfrim () {
			this.hide().then(() => {
				this.$emit('on-confirm-click')
				if (typeof this.confirmHandler === 'function') {
					this.confirmHandler()
				}
			})
		},
		onCancel () {
			this.hide().then(() => {
				this.$emit('on-cancel-click')
				if (typeof this.cancelHandler === 'function') {
					this.cancelHandler()
				}
			})
		},
		hide () {
			return new Promise(resolve => {
				this.$emit('input', false)
				this.actionShow = false
				setTimeout(() => {
					this.visible = false
					this.$emit('on-hide')
					resolve()
				}, 200)
			})
		}
	}
}
</script>
<style scoped>
	.tips-mask-t{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 50;
		background-color: rgba(0,0,0,.4);
		/*opacity: 0;*/
	}
	.tips-mask-t .tips-wrapper{
		position: absolute;
		width: 100%;
		margin-top: -90px;
		background-color: #eee;
		box-shadow: 0px 5px 10px rgba(0,0,0,.1)
	}
	.tips-mask-t .tips-wrapper .tips-font{
		margin: 0;
		text-align: center;
		border-bottom: solid 1px #f3f3f3;
		box-sizing: border-box;
		vertical-align: middle;
		background-color: #fff;
	}
	.tips-mask-t .tips-wrapper .tips-font p{
		height: auto;
		vertical-align: middle;
		font-size: .9em;
		margin: 0;
		padding: 10px;
		color: #aaa;
	}
	.tips-mask-t .tips-wrapper .tips-btns{
		margin: 0;
		padding: 0;
		text-align: center;
	}
	.tips-mask-t .tips-wrapper .tips-btns .tips-two-btn{
		display: block;
		font-size: 1.2em;
		width: 100%;
		padding: .6em 0;
		box-sizing: border-box;
		background-color: #fff;
	}
	.tips-mask-t .tips-wrapper .tips-btns .tips-one-btn{
		display: block;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		/*color:#25b8d4;*/
		color:#6495ed;
	}
	.tips-mask-t .tips-wrapper .tips-btns .tips-marbot{
		margin-bottom: .5em;
	}
	.tips-start{
		bottom: 0%;
		animation: tipsStart .3s;
		-webkit-animation: tipsStart .3s;
	}
	@keyframes tipsStart
	{
		from {bottom: -40%;}
		to {bottom: 0%;}
	}
	@-webkit-keyframes tipsStart
	{
		from {bottom: -40%;}
		to {bottom: 0%;}
	}
	.tips-end{
		bottom: -40%;
		animation: tipsEnd .3s;
		-webkit-animation: tipsEnd .3s;
	}
	@keyframes tipsEnd
	{
		from {bottom: 0%;}
		to {bottom: -40%;}
	}
	@-webkit-keyframes tipsEnd
	{
		from {bottom: 0%;}
		to {bottom: -40%;}
	}
</style>


// WEBPACK FOOTER //
// Confirm-sheet.vue?5b604f40